<template>
  <div>
    <p class="title">{{ $t('account.forgotPassword') }}</p>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="60px"
    >
      <p class="tip">
        <i class="el-icon-warning" />
        {{ $t('account.forgotPasswordDesc') }}
      </p>

      <el-form-item
        :label="$t('account.email')"
        prop="email"
      >
        <el-input
          v-model="form.email"
          size="medium"
          :placeholder="$t('account.emailPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      class="sub-btn"
      @click="handleSubmit"
      :loading="loading"
    >
      {{ $t('account.submit') }}
    </el-button>

    <p class="err-msg" v-if="errMsg">
      {{ errMsg }}
    </p>
  </div>
</template>

<script>
import authService from '@/api/auth'
import { getErrorCode, validatorEmail, getDefaultErrorText } from './mixin'
import { ls } from '@/utils/index'
import { logout } from '@/utils/auth'

export default {
  name: 'ForgetPwd',

  data() {
    return {
      loading: false,
      errMsg: '',
      rules: {
        email: [
          { required: true, message: this.$t('account.emailPlaceholder'), trigger: 'blur' },

          {
            validator: validatorEmail, trigger: 'blur'
          }
        ],
      },
      form: {
        email: ''
      }
    }
  },

  methods: {
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }
      this.errMsg = ''
      try {
        this.loading = true
        const { code } = await authService.forgetPassword({
          email: this.form.email,
          lang: ls.getItem('lang', 'zh')
        })
        if (code === 200) {
          this.$refs.form.resetFields()
          this.$message.success(this.$t('account.forgetSuccessMessage'))
          logout()
        } else {
          this.errMsg = getErrorCode()[code]
        }
      } catch (e) {
        this.errMsg = getDefaultErrorText()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.tip {
  margin-left: 60px;
  font-size: 14px;
  margin-bottom: 10px;
  color: #909399;
}

</style>
